var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolidSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-park-solid:success",
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "icon-park-solid:success-2",
    "data-name": "icon-park-solid:success",
    width: 105,
    height: 105,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_group",
    "data-name": "Mask group",
    transform: "translate(10.872 8.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.535,0,53.005,8.368l14.2-.026,4.361,13.512,11.5,8.324L78.656,43.672l4.413,13.495-11.5,8.324L67.205,79l-14.2-.026L41.535,87.345,30.064,78.977,15.864,79,11.5,65.491,0,57.167,4.413,43.672,0,30.178l11.5-8.324L15.864,8.341l14.2.026Z",
    transform: "translate(0)",
    fill: "#2f80ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M32.754,0,10.918,21.836,0,10.918",
    transform: "translate(26.249 32.754)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11.167
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidSuccess);
export default __webpack_public_path__ + "static/media/solid-success.c37302a8f2446151663ff642e511517c.svg";
export { ForwardRef as ReactComponent };